import { useStaffMode } from "./StaffModeProvider";

/**
 * True on StaffRoutes, SuperAdminRoutes, staff legacy paths, and Manage Firm.
 * Those are the paths that turn staff mode on. Member, public, and data admin
 * routes stay false, so shared components can pick short vs long from this.
 */
export function useStaffFirmSurface(): boolean {
  const { isStaffMode } = useStaffMode();
  return isStaffMode;
}
